import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstructorForCompanyComponent } from './instructor-for-company.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { createTranslateLoader } from '../../http-loader-factory';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AutocompleteListComponent } from '../../components/autocomplete-list/autocomplete-list.component';
@NgModule({
  imports: [
    CommonModule,
    AutocompleteListComponent,
    MatDialogModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
  ],
  declarations: [InstructorForCompanyComponent],
  exports: [InstructorForCompanyComponent],
})
export class InstructorForCompanyModule {}
